// components
import Iconify from '../../../components/Iconify';


const sidebarConfig = [
  {
    subheader: '',
    items: [
      { title: 'Dashboard ', path: '/dashboard', icon: <Iconify icon="material-symbols:dashboard-rounded"/> },
      { title: 'Contracts', path: '/contracts', icon: <Iconify icon="ph:code-bold"/> },
      { title: 'Mints', path: '/mints', icon: <Iconify icon="material-symbols:image"/> },
      { title: 'Bridge', path: '/bridge', icon: <Iconify icon="mingcute:bridge-line"/> },
    ],
  },
];

export default sidebarConfig;
